import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ResponseCatalog, RequestParams } from 'Models'
import { Callback } from 'Src/types/utilTypes'
import { BgBlackList, CreateBgBlackListItem } from 'Pages/ibro'

export type BgBlackListSlice = {
	blackList: ResponseCatalog<BgBlackList>
	requestParams: RequestParams
}

export const bgBlackListInitialState: BgBlackListSlice = {
	blackList: new ResponseCatalog<BgBlackList>(),
	requestParams: new RequestParams(),
}

export namespace BgBlackListNs {
	export type GetBlackList = PayloadAction<{
		params: RequestParams
		clear?: boolean
		callback?: Callback
	}>
	export type SetBlackList = PayloadAction<ResponseCatalog<BgBlackList>>
	export type CreateBlackListItem = PayloadAction<CreateBgBlackListItem>
	export type UpdateBlackListItem = PayloadAction<BgBlackList>
	export type DeleteBlackListItem = PayloadAction<{ id: number }>
	export type SetRequestParams = PayloadAction<RequestParams>
	export type ClearBlackList = PayloadAction<undefined>
}

export const bgBlackListSlice = createSlice({
	name: 'bgBlackList',
	initialState: bgBlackListInitialState,
	reducers: {
		getBlackList: (state, action: BgBlackListNs.GetBlackList) => {},
		setBlackList: (state, action: BgBlackListNs.SetBlackList) => {
			state.blackList = action.payload
		},
		setRequestParams: (state, action: BgBlackListNs.SetRequestParams) => {
			state.requestParams = action.payload
		},
		createBlackListItem: (state, action: BgBlackListNs.CreateBlackListItem) => {},
		updateBlackListItem: (state, action: BgBlackListNs.UpdateBlackListItem) => {},
		deleteBlackListItem: (state, action: BgBlackListNs.DeleteBlackListItem) => {},
		clearBlackList: (state, action: BgBlackListNs.ClearBlackList) => {
			state.blackList = new ResponseCatalog<BgBlackList>()
		},
	},
})
